import React, { type FC, type JSX } from 'react';
import type { Localization } from '@/app/components/search/common/Localization.ts';
import { useTranslation } from '@/app/components/translations/Translation';
import { BRAND_IMAGES, getBrandImageUrl } from '@/app/common/contentHubAssets.ts';
import { OvernightFlightsMessageContainer, OvernightFlightsMessageImage, OvernightFlightsMessageText } from './styled';

type OvernightFlightsProps = {
  localization: Localization;
  style?: React.CSSProperties;
};

const OvernightFlightsMessage: FC<OvernightFlightsProps> = ({ localization, style }): JSX.Element => {
  const { t } = useTranslation();
  const filterMessage = t('vacation.oss.overnight_flight.filter.message');
  const label = t('vacation.oss.overnight_flight.label');
  const image = getBrandImageUrl(BRAND_IMAGES.OVERNIGHT, localization);

  return (
    <OvernightFlightsMessageContainer style={style}>
      <OvernightFlightsMessageImage src={image} alt={label} />
      <OvernightFlightsMessageText>{filterMessage}</OvernightFlightsMessageText>
    </OvernightFlightsMessageContainer>
  );
};

export default OvernightFlightsMessage;
